<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Half Title">
<p class="hf"><span class="right_1" epub:type="pagebreak" id="page_xv" title="xv">UPROOTING THE</span></p>
<p class="hf1">DIASPORA<span class="right_1" epub:type="pagebreak" id="page_xvi" title="xvi"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253064967_Halftitle1.vue?2b44aa7c